import React from "react";
import { SCREEN_PATHS } from "./constants";

import { AppLayout } from "./layouts/AppLayout";
import { FlowLayout } from "./layouts/FlowLayout";
import { NotAuthedLayout } from "./layouts/NotAuthedLayout";
import { Home } from "./views/home";
// import { MaintenanceView } from "./views/maintenance/MaintenanceView";
import { NotFoundView } from "./views/error/NotFoundView";
import { Navigate } from "react-router-dom";
// import { CognitoAuthView } from "./views/auth/CognitoAuthView";

import { FlowScreenLoader } from "./views/flows/shared/FlowScreenLoader";
import {
  noticeToCreditorsFlow,
  onBoardingFlow,
  financialConvoFlow,
  primaryHomeFlow,
} from "./views/flows";
import { Invite } from "./views/auth/Invite";
// import { Checklist } from "./views/checklist";
import { AuthContextWrapper } from "./AuthContextWrapper";
import { EstateContextWrapper } from "./EstateContextWrapper";

import { FinancialConvoContextWrapper } from "./FinancialConvoContextWrapper";
import { SignOut } from "./views/auth/SignOut";
import { Redirect } from "./components/Redirect";
import { MaintenanceView } from "./views/maintenance/MaintenanceView";
import { ProbateQuestionScreen } from "./views/formsAndFiles/probate/ProbateQuestionScreen";
import { AssembleScreen } from "./views/formsAndFiles/probate/AssembleScreen";
import { ConfirmScreen } from "./views/formsAndFiles/probate/ConfirmScreen";
import FormsAndFilesScreen from "./views/formsAndFiles";
import { ProbateReviewScreen } from "./views/formsAndFiles/probate/ProbateReviewScreen";
import { ProbateContextWrapper } from "./ProbateContextWrapper";
import { Probate } from "./views/formsAndFiles/probate/Probate";
import { AssetContextWrapper } from "./AssetContextWrapper";
import { AuthScreen } from "./views/auth/AuthScreen";
import EstateFormsView from "views/formsAndFiles/EstateFormsView";
import FormsLibraryEstateView from "views/formsAndFiles/FormsLibraryEstateView";

const routes = [
  {
    path: "app",
    element: (
      <AuthContextWrapper>
        <EstateContextWrapper>
          <AppLayout />
        </EstateContextWrapper>
      </AuthContextWrapper>
    ),
    children: [
      { path: "home", element: <Home /> },
      // { path: "checklist", element: <Checklist /> },
      {
        path: "forms-and-files",
        // element: <></>,
        children: [{ path: "", element: <FormsAndFilesScreen /> }],
      },
      // We'll use the same element but a different url for this page, this is useful for triggering intercom
      {
        path: "packet/forms-and-files",
        children: [{ path: "", element: <FormsAndFilesScreen /> }],
      },
      {
        path: "forms-and-files/estate-forms",
        element: <EstateFormsView />,
      },
      {
        path: "forms-and-files/forms-library",
        element: <FormsLibraryEstateView />,
      },
      {
        path: "forms-and-files/probate",
        element: (
          <ProbateContextWrapper>
            <Probate />
          </ProbateContextWrapper>
        ),
        children: [
          { path: "", element: <ProbateQuestionScreen /> },
          { path: "review", element: <ProbateReviewScreen /> },
          { path: "assemble", element: <AssembleScreen /> },
          { path: "confirm", element: <ConfirmScreen /> },
        ],
      },
    ],
  },
  {
    path: "flow",
    element: (
      <AuthContextWrapper>
        <FlowLayout />
      </AuthContextWrapper>
    ),
    children: [
      {
        path: noticeToCreditorsFlow.flowPath, // will redirect to first screen
        element: <FlowScreenLoader flow={noticeToCreditorsFlow} />,
      },
      {
        path: `${noticeToCreditorsFlow.flowPath}/:screenName`,
        element: <FlowScreenLoader flow={noticeToCreditorsFlow} />,
      },
      {
        path: onBoardingFlow.flowPath, // will redirect to first screen
        element: <FlowScreenLoader flow={onBoardingFlow} />,
      },
      {
        path: `${onBoardingFlow.flowPath}/:screenName`,
        element: <FlowScreenLoader flow={onBoardingFlow} />,
      },
      {
        path: financialConvoFlow.flowPath, // will redirect to first screen
        element: (
          <FinancialConvoContextWrapper>
            <FlowScreenLoader flow={financialConvoFlow} />
          </FinancialConvoContextWrapper>
        ),
      },
      {
        path: `${financialConvoFlow.flowPath}/:screenName`,
        element: (
          <FinancialConvoContextWrapper>
            <FlowScreenLoader flow={financialConvoFlow} />
          </FinancialConvoContextWrapper>
        ),
      },
      {
        path: primaryHomeFlow.flowPath, // will redirect to first screen
        element: (
          <AssetContextWrapper>
            <FlowScreenLoader flow={primaryHomeFlow} />
          </AssetContextWrapper>
        ),
      },
      {
        path: `${primaryHomeFlow.flowPath}/:screenName`,
        element: (
          <AssetContextWrapper>
            <FlowScreenLoader flow={primaryHomeFlow} />
          </AssetContextWrapper>
        ),
      },
    ],
  },
  {
    path: "/",
    element: <NotAuthedLayout />,
    children: [
      { path: "auth", element: <AuthScreen /> },
      { path: "maintenance", element: <MaintenanceView /> },
      { path: "invite/:inviteId", element: <Invite /> },
      { path: "invite", element: <Invite /> },
      { path: "sign-out", element: <SignOut /> },
      { path: "404", element: <NotFoundView /> },
      {
        path: "/",
        element: <Redirect to={SCREEN_PATHS.auth} />,
      },
      {
        path: "*",
        element: <Navigate to={SCREEN_PATHS.not_found} replace={true} />,
      },
    ],
  },
];

export default routes;
